import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function DressCode() {
  return (
    <section className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <ScrollReveal>
          <p className="micro-label mb-5 text-foreground-500">Código de vestimenta</p>
          <div className="mx-auto h-px w-16 bg-primary-300" />
        </ScrollReveal>

        <ScrollReveal delay={1}>
          <div className="mt-10 md:mt-12">
            <p className="font-heading text-2xl font-light italic text-primary-700 sm:text-3xl md:text-4xl">
              {weddingConfig.dressCode}
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={2}>
          <p className="mx-auto mt-8 max-w-md font-body text-sm leading-relaxed text-foreground-500 sm:text-base">
            {weddingConfig.dressCodeNotes}
          </p>
        </ScrollReveal>

        {weddingConfig.dressCodeRestriction && (
          <ScrollReveal delay={3}>
            <p className="mt-6 font-body text-xs italic text-foreground-400 sm:text-sm">
              {weddingConfig.dressCodeRestriction}
            </p>
          </ScrollReveal>
        )}

        <ScrollReveal delay={3}>
          <div className="mt-12 flex items-center justify-center gap-4">
            <span className="h-px w-16 bg-primary-300" />
            <span className="h-1.5 w-1.5 rotate-45 bg-primary-400" />
            <span className="h-px w-16 bg-primary-300" />
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}